<bit-header></bit-header>
<div class="content">
  <div class="lg:container relative z-10 pt-6 px-5 pb-12">
    <h1 class="mt-10 sm:mt-16 mb-6">{{title}}</h1>
    <div class="flex items-start">
      <div [class]="'dynamic-content ' + slug+'-content'" [innerHTML]="content"></div>
      <img *ngIf="slug === 'about'" class="w-[40%] hidden lg:block object-contain" src="assets/images/about-us/about-us.webp" width="598" height="1000" alt="about-us">
    </div>
  </div>
  <bit-footer></bit-footer>

</div>
